import React, { Component } from 'react';
// core components
import FlashState from 'helpers/flashState';
import Snackbar from 'components/UI/Snackbar/Snackbar';

/**
 * @class
 * @extends Component
 */
class RedirectFlashMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
    };
  }

  /**
   * @description
   * Get flash messages.
   *
   * @returns {undefined} - No returns value.
   */
  componentDidMount() {
    const message = FlashState.get('message');
    if (message) this.setState({ message });
  }

  /**
   * @description
   * Close notification.
   *
   * @returns {*} - No returns value.
   */
  handleCloseNotification = () => this.setState({ message: '' });

  render() {
    const { message } = this.state;
    return (
      <Snackbar
        place="tc"
        color="success"
        message={message}
        open={message !== ''}
        closeNotification={() => this.handleCloseNotification()}
        close
      />
    );
  }
}

export default RedirectFlashMessage;
